import type { State } from '../configureStore'
import { Privileges as ActionTypes } from '../actionTypes'
import { defaultState } from '../reducers/privileges/default.state'
import type { PrivilegeSummaryItem } from '../reducers/privileges/models'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import { PrivilegesView } from '@src/modules/privileges/configurations'

// Action Creators
export type ActionTypes =
  | getStatSuccessAction
  | serverErrorsAction
  | requestPendingAction
  | getOverviewStatsSuccessAction

const getStatSuccess = ReduxHelpers.Common.Actions.setToState(
  ActionTypes.GET_STAT_SUCCESS,
  defaultState
)
type getStatSuccessAction = ReturnType<typeof getStatSuccess>

const getOverviewStatsSuccess = (
  list: PrivilegeSummaryItem[],
  isPending = false
) =>
  ReduxHelpers.Actions.createPayloadAction(
    ActionTypes.GET_OVERVIEW_STATS_DATA,
    {
      list,
      isPending
    }
  )
type getOverviewStatsSuccessAction = ReturnType<typeof getOverviewStatsSuccess>

const serverErrors = (errors: any) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.SERVER_ERRORS, {
    errors,
    isPending: false
  })
type serverErrorsAction = ReturnType<typeof serverErrors>

const requestPending = (isPending: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(ActionTypes.REQUEST_PENDING, {
    isPending
  })
type requestPendingAction = ReturnType<typeof requestPending>

export function selectView(view: PrivilegesView) {
  return (dispatch, getState: () => State) => {
    const { privileges } = getState()
    const { selectedView } = privileges
    if (selectedView !== view) {
      dispatch(getStatSuccess('selectedView', view))
    }
  }
}
